import React from 'react';
import cx from 'clsx';
import { product as productLabels } from '../../mockdata';
import Container from '../Container/Container';
import Title from '../Title/Title';
import Text from '../Text/Text';
import Anchor from '../Anchor/Anchor';
import LanguageSelector from '../LanguageSelector/LanguageSelector';
import Disclaimer from '../Disclaimer/Disclaimer';
import classes from './IndexWrapper.module.scss';

// Product keys that should display the Disclaimer button (GWP-1212).
// Configurable via env so more products can be added later without a code change.
// Comma-separated list; defaults to the iTero Lumina™ PC-configuration scanner.
const DISCLAIMER_PRODUCT_IDS = (
  process.env.NEXT_PUBLIC_DISCLAIMER_PRODUCT_IDS || 'iTero-Lumina-PC-config'
)
  .split(',')
  .map((id) => id.trim())
  .filter(Boolean);

interface IndexWrapperProps extends Omit<React.HTMLProps<HTMLDivElement>, 'size'> {
  className?: string;
  locale: string;
  labels: typeof productLabels;
  hide_language_selector?: boolean;
  hide_back_link?: boolean;
  backLink?: { href: string; children: string };
  disableNotePadding?: boolean;
  localeCountry?: string;
  productId?: string;
}

export default function IndexWrapper({
  className,
  locale,
  name,
  hide_language_selector,
  hide_back_link,
  backLink,
  labels,
  children,
  disableNotePadding,
  localeCountry,
  productId,
  ...others
}: IndexWrapperProps) {
  const showDisclaimer = !!productId && DISCLAIMER_PRODUCT_IDS.includes(productId);
  return (
    <Container className={cx(classes.container, className)} {...others}>
      {!hide_back_link && <Anchor {...backLink} className={classes.backLink} />}
      <Title order={1} className={classes.title}>
        {name}
      </Title>
      {(!hide_language_selector || showDisclaimer) && (
        <div className={classes.selectorRow}>
          {!hide_language_selector && (
            <LanguageSelector locale={locale} localeCountry={localeCountry} />
          )}
          {showDisclaimer && <Disclaimer />}
        </div>
      )}
      {children}
      <Text<HTMLDivElement>
        component="div"
        className={cx(classes.note, {
          [classes.noPadding]: disableNotePadding,
        })}
        dangerouslySetInnerHTML={{ __html: labels.notes }}
      />
    </Container>
  );
}
